import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'rc-slider/lib/Slider'
import './CustomSlider.css'

const CustomSlider = ({
  onAfterSliderChange,
  onSliderChange,
  id,
  min,
  max,
  defaultValue
}) => {
  const handleOnChange = value => {
    onSliderChange(value)
  }

  const handleOnAfterChange = value => {
    onAfterSliderChange(value, id)
  }

  return (
    <Slider
      onChange={handleOnChange}
      onAfterChange={handleOnAfterChange}
      tipFormatter={null}
      min={min}
      max={max}
      defaultValue={defaultValue}
    />
  )
}

CustomSlider.propTypes = {
  onAfterSliderChange: PropTypes.func.isRequired,
  onSliderChange: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  defaultValue: PropTypes.number
}

export default CustomSlider



// WEBPACK FOOTER //
// ./src/components/CustomSlider/CustomSlider.js